export default __webpack_public_path__ + "static/media/button.d3902b52.mp3";